import { shallowEqual, useSelector } from "react-redux";
import { Toast } from "Components/Toast/Index";
import { TOAST_DELAY } from "Constantes/constants";
import SideBar from "Components/SideBar/Index";
import Contenido from "Pages/Contenido/Index";
import AppHeader from "Components/SideBar/AppHeader/Index";
import "./Administrador.css";

const DashboardAdmin = () => {
  const showToast = useSelector((state) => state.ui.showToast);
  const response = useSelector(
    (state) => state.response.response,
    shallowEqual
  );

  return (
    <div style={{ display: "flex" }}>
      <SideBar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1 px-3">
          <Toast
            autohide={true}
            delay={TOAST_DELAY}
            visible={showToast}
            color={
              response?.result === 1 || response?.result ? "success" : "danger"
            }
            message={response?.message}
          />
          <Contenido />
        </div>
      </div>
    </div>
  );
};

export default DashboardAdmin;
